/**
 * Feature code → readable name. The codes are fixed by the cloud license service and are
 * what clients match on; this map exists purely so the panel does not show bare uuids.
 */
export const ApplicationFeatureNames: Record<string, string> = {
  '052c4695-f4d4-42c5-bd54-8b2fe5a27e4a': 'Composer Pro',
  '526a1add-cdc0-457e-8f46-51afa3556e98': 'Advanced Workflow',
  'ee00cab8-098c-41da-b5d9-7fa5b636d788': 'Advanced Visualization',
  'b180e18d-8ac2-4520-8e45-17590022b2df': 'AI',
  'c6c4aba5-32e3-4c7b-a423-a50aa5f0bd52': 'AI Tools',
  'd5158c88-aabd-4826-84c9-d9e2d28cdf08': 'AI Test',
  '4ff6650a-25be-4e0b-af89-c954a825bb2d': 'SuPAR Insight',
};
